import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Monteerimisjuhend

  <span style="color:#85c1dc;">**FI:**</span>
  Kasausohje

  <span style="color:#85c1dc;">**RU:**</span>
  Инструкция по сборке
*/
/* @__NO_SIDE_EFFECTS__ */
const m1361 = msg(
  mf`Monteerimisjuhend`,
  mf`Kasausohje`,
  mf`Инструкция по сборке`,
)

export { m1361 as 'w.module.product_description.montage' }